document.addEventListener('click', function (event) {
  document.querySelectorAll('.loulou-switcher.is-open').forEach(function (switcher) {
    if (!switcher.contains(event.target)) {
      switcher.classList.remove('is-open');
    }
  });
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('.loulou-switcher.is-open').forEach(function (switcher) {
      switcher.classList.remove('is-open');
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  const visiblePhoneInput = document.querySelector('#ContactForm-phone-visible');
  const hiddenPhoneInput = document.querySelector('#ContactForm-phone');
  const hiddenCountryInput = document.querySelector('#ContactForm-phone-country');

  if (!visiblePhoneInput || !hiddenPhoneInput || typeof window.intlTelInput === 'undefined') {
    return;
  }

  const iti = window.intlTelInput(visiblePhoneInput, {
    initialCountry: 'fr',
    preferredCountries: ['fr', 'be', 'de', 'lu'],
    separateDialCode: true,
    nationalMode: true,
    formatAsYouType: true,
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js'
  });

  function updatePhoneFields() {
    const countryData = iti.getSelectedCountryData();
    const dialCode = countryData?.dialCode ? '+' + countryData.dialCode : '';
    const countryIso = countryData?.iso2 ? countryData.iso2.toUpperCase() : '';
    const fullNumber = iti.getNumber();

    hiddenPhoneInput.value = fullNumber || (dialCode + ' ' + visiblePhoneInput.value).trim();

    if (hiddenCountryInput) {
      hiddenCountryInput.value = `${countryIso} ${dialCode}`.trim();
    }
  }


  visiblePhoneInput.addEventListener('countrychange', updatePhoneFields);
  visiblePhoneInput.addEventListener('input', updatePhoneFields);

  const form = visiblePhoneInput.closest('form');

  if (form) {
    form.addEventListener('submit', function () {
      updatePhoneFields();
    });
  }
});


